<template>
	<div>
		<buttonlist
			@help="help"
			@opentable="opentable"
			@search="search"
			@reflash="reflash"
			@exps="exps"
			ref="SetBtn"
		></buttonlist>
		<wTable
				id="xpane-0"
				:data="dataSet"
				:loading="loading"
				queryData="ProMPSLineViewInfo"
				:filter_language="['active_flag']"
				:filter_thousandth="['forecast_qty','mps_qty']"
				:filter_date="['mrp_date']"
				:header="tableHeader"
				:option="tableOption"
				ref="singleTable"
				:checkflg="false"
		></wTable>
		<!--<el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[137]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="start_period" :label="$t('getapi[7024]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="end_period" :label="$t('getapi[7025]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="active_flag" :label="$t('getapi[7026]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="mps_type" :label="$t('getapi[7027]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="mrp_type" :label="$t('getapi[7028]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="data_process_type" :label="$t('getapi[7029]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="mrp_date" :label="$t('getapi[4053]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="calc_time" :label="$t('getapi[2515]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="supply_notice" :label="$t('getapi[7041]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="require_notice" :label="$t('getapi[7042]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="forecast_qty" :label="$t('getapi[6364]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="mps_qty" :label="$t('getapi[7043]')" align="right"></el-table-column>
		</el-table>-->
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="ProMPSLineViewInfo" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[3991]')" queryData="ProMPSLineViewInfo" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'2_mpsdetailview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
            tableHeader: [],
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('2_mpsdetailview'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
        that.colsort();
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('ProMPSLineViewInfo', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3991]"),this.$t("getapi[26]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 173, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			var limits = that.$limits.OperationAuthorityView('plv2', 173, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('2_mpsdetailview',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'ProMPSLineViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Pro/MPS/MPSOverViewDataList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				} else {
					that.$message.error(res.Msg);
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			/*let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
            that.$refs.SetBtn.SetOneBtnEnable('exps',false);
			that.$http.urlpost('/Pro/MPS/MPSOverViewExportToExecl', parm, function(res) {
                that.$refs.SetBtn.SetOneBtnEnable('exps',true);
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "ProMPSLineViewInfo",
                fromname: that.$t('getapi[3991]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
